import Api from "./Api";

const endpoint = "/howto";
export default {
    get() {
        return Api.fetchData(endpoint);
    }
};
